import React, { FC } from 'react'
import Dropdown from 'src/components/Atoms/Dropdown/Dropdown'
import t from '../../../translations/main'
import { DropdownProps } from 'src/components/Atoms/Dropdown/types'

import { DropdownWrapperStyles } from './DropdownWrapper.styles'
import { FlexProps } from 'src/components/Layout/Flex/Flex'

const CountryDropdownWrapper: FC<DropdownProps & FlexProps & { wrapperMinHeight?: string, gridArea?: string, wrapperWidth?: string}> = props => {

  const {
    options,
    label,
    placeholder,
    value,
    name,
    required,
    // @ts-ignore
    customOnChange,
    marginInputWrapper,
    filter,
    multiple,
    wrapperMinHeight,
    gridArea,
    wrapperWidth,
    removeEllipsis,
    disabled,
    bgTransparent
  } = props

  // @ts-ignore
  const callCustomOnChange = event => {
    customOnChange(
      {
        ...event,
        value: !multiple
          ? event?.options[`${event?.value}`]?.index?.toString()
          : {
            index: event?.index?.toString() ,
            itemIndex: event?.options[`${event?.value}`]?.index?.toString()
          }
      }
    )
  }

  const getSingleItem = () => {
    const index = options?.findIndex(item => item?.index?.toString() === value?.toString()).toString()
    return index !== '-1' ? index : ''
  }

  const getMultipleValue = () => Array.isArray(value) ? value?.map(value => value?.index?.toString()) : []

  return (
    <DropdownWrapperStyles
      wrapperMinHeight={wrapperMinHeight}
      gridArea={gridArea}
      wrapperWidth={wrapperWidth}
      alignItems={props.alignItems}
      disabled={disabled}
    >
      <Dropdown
        label={t(label.toString())}
        removeEllipsis={removeEllipsis}
        placeholder={t(placeholder)}
        options={options}
        noReset={true}
        // @ts-ignore:next-line
        value={multiple
          // @ts-ignore:next-line
          ? getMultipleValue()
          : getSingleItem()
        }
        name={name}
        required={required}
        onChange={callCustomOnChange}
        marginInputWrapper={marginInputWrapper}
        inputUpperCase={true}
        filter={filter}
        multiple={multiple}
        // @ts-ignore
        outsideSelectedList={Array.isArray(value) && value?.map(item => parseInt(item.index)) || []}
        bgTransparent={bgTransparent}
      />
    </DropdownWrapperStyles>
  )
}

export default CountryDropdownWrapper
